module.exports = __webpack_public_path__ + "static/media/girl2.b868415f.svg";